import { FormGridField } from "../../components/FormGrid";

export interface SelectMenuDefinition {
    name: string;
    id: string;
    noValueLabel: string;
    label: string;
    items: { label: string | number; value: string | number }[];
    schemaName: string;
    sourceChanges?: boolean;
    fieldOverrides?: any;
    disabled?: boolean;
    headerContainer?: any;
    buildFormGridField: (schema) => FormGridField;
}

export default function buildSelectMenuDefinition({
    name,
    id,
    noValueLabel,
    label,
    items,
    schemaName,
    sourceChanges,
    fieldOverrides,
    disabled,
    headerContainer
}: {
    name: string;
    id: string;
    noValueLabel: string;
    label: string;
    items: { label: string | number; value: string | number }[];
    schemaName: string;
    sourceChanges?: boolean;
    fieldOverrides?: any;
    disabled?: boolean;
    headerContainer?: any;
}): SelectMenuDefinition {
    return {
        name,
        id,
        noValueLabel,
        label,
        items,
        schemaName,
        sourceChanges,
        fieldOverrides,
        disabled,
        headerContainer,
        buildFormGridField: _createSelectField
    };
}

function _createSelectField(schema): FormGridField {
    const {
        name,
        id,
        label,
        noValueLabel,
        items,
        schemaName,
        sourceChanges,
        fieldOverrides,
        disabled,
        headerContainer
    } = this;

    const multipleSelection =
        fieldOverrides !== undefined &&
        fieldOverrides.multipleSelection !== undefined
            ? fieldOverrides.multipleSelection
            : false;

    return {
        name,
        fieldType: "select",
        fieldOptions: {
            id,
            noValueLabel,
            label,
            items,
            sourceChanges,
            multipleSelection,
            disabled,
            headerContainer
        },
        validationSchema: {
            ...schema.properties[schemaName],
            required: schema.hasOwnProperty("required")
                ? schema.required.includes(name)
                : false
        },
        columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-6",
        formSpacing: true,
        ...fieldOverrides
    };
}
